import { createContext } from 'react';
import type { SkillsScope } from './types';

const SkillsScopeContext = createContext<SkillsScope | null>(null);

export default SkillsScopeContext;
